/* ********************************
 *         Data Loaders
 * ********************************
 */

/* eslint-disable no-unused-vars */
import {state} from "./index";
import store from "@/store";
// // import { getSubjectsBySubjectGroup } from "@/services/api/common-data";
// // import { getCourseOutlines } from "@/services/api/course-outline";

/**
 *  Load Data
 *
 *  @return No return.
 *
 */

export const loadData = async (filter) => {

  const loaderTimeout = setTimeout(() => {
    state.local.loading.list = false;
    state.local.status.list = { active: true, message: "Time out" }
  }, 10000);

  try {
    // Set loading state
    state.local.loading.list = true;

    // Purge previous list items.
    // Do not use = [] cause it will break observable and reactivity.
    state.local.list = state.local.list.filter(i => !i);

    //
    const result =
      await store.dispatch("Examination/getExamQuestionListByFilter", { examQuestionsFilterInput: filter });

    //
    const { status, data } = result;

    // Set new data to the list.
    if (status.success && Array.isArray(data)) {
      state.local.list = data;

      if (data.length < 1) {
        state.local.status.list = {active: true, message: "No Data"};
      }
      clearTimeout(loaderTimeout);
      state.local.loading.list = false;
    }

    // Set new options to selectors.

  } catch (e) {
    return e;
    // TODO: Handle Error
    // console.log(e);
  }
};


/**
 *  Load Selector Options
 *
 *  @return No return.
 *
 */

export const loadSelectors = async () => {

};


/**
 *  Load Academic Periods Options
 *
 *  @return No return.
 *
 */

export const loadAcademicPeriods = async () => {
  store.dispatch("CommonData/AcademicPeriod/getAcademicPeriods");
};


/**
 *  Load Degree Options
 *
 *  @return No return.
 *
 */

export const loadDegrees = async () => {
  store.dispatch("CommonData/Degree/getDegrees");
};


/**
 *  Load Subject Group Options
 *
 *  @return No return.
 *
 */

export const loadSubjectGroups = async () => {
  store.dispatch("CommonData/SubjectGroup/getSubjectGroups");
};


/**
 *  Load Subject Options by Subject Group Id
 *
 *  @return No return.
 *
 */

export const loadSubjects = async (subjectGroupId) => {
  // console.log("Use subject group id", subjectGroupId);
  const payload = { subjectGroupId };
  state.local.selectorOptions.subject = await store.dispatch("CommonData/Subject/getSubjectBySubjectGroupID", payload);
};

/**
 *  Load Teacher Options
 *
 *  @return No return.
 *
 */

export const loadTeacherList = async () => {
  await store.dispatch("Profile/getTeachers");
};

export const loadCourseOutlineByFilter = async (subjectGroupId) => {
  const payload = { courseOutlineFilterInput: { subjectGroupId } };
  const result = await store.dispatch("Courses/CourseOutline/getCourseOutlineByFilter", payload);

  const { status, data } = result;
  if (status.success) {
    state.local.selectorOptions.courseOutline = data;
  }
};
